import { BlobViewer, initAuxiliaryViewer } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/blob/viewer/index.js?vue3';
import initBlob from '/builds/gitlab/gitlab-ee/app/assets/javascripts/pages/projects/init_blob.js?vue3';
import { initWebIdeLink } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/pages/projects/shared/web_ide_link/init_web_ide_link.js?vue3';
import '~/sourcegraph/load';
import initAmbiguousRefModal from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/ref/init_ambiguous_ref_modal.js?vue3';
import initRepositoryPage from '/builds/gitlab/gitlab-ee/app/assets/javascripts/repository/init_repository_page.js?vue3';
import apolloProvider from '/builds/gitlab/gitlab-ee/app/assets/javascripts/repository/graphql.js?vue3';
import { showAlertFromLocalStorage } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/local_storage_alert/index.js?vue3';
import initForkInfoApp from '/builds/gitlab/gitlab-ee/app/assets/javascripts/repository/init_fork_info_app.js?vue3';
import initTableOfContentsApp from '/builds/gitlab/gitlab-ee/app/assets/javascripts/blob/init_table_of_contents_app.js?vue3';
import initPerformancePlugin from '/builds/gitlab/gitlab-ee/app/assets/javascripts/performance/init_performance_plugin.js?vue3';

export default function initBlobShow() {
  // eslint-disable-next-line @gitlab/require-i18n-strings
  const performancePluginComponents = ['SourceViewer', 'Chunk'];
  const viewBlobEl = document.getElementById('js-view-blob-app');
  const webIdeLinkEl = document.getElementById('js-blob-web-ide-link');
  const codeNavEl = document.getElementById('js-code-navigation');

  // The expanded view renders code owners without the Vue blob app, so there is
  // no router on that path and callers get null.
  let router = null;

  initPerformancePlugin(performancePluginComponents);
  initAmbiguousRefModal();
  showAlertFromLocalStorage();

  if (viewBlobEl) {
    ({ router } = initRepositoryPage());
    initAuxiliaryViewer();
    initBlob();
  } else {
    new BlobViewer(); // eslint-disable-line no-new
    initBlob();
    initForkInfoApp();
  }

  initWebIdeLink({ el: webIdeLinkEl });

  if (codeNavEl && !viewBlobEl) {
    const { codeNavigationPath, blobPath, definitionPathPrefix } = codeNavEl.dataset;
    // eslint-disable-next-line promise/catch-or-return
    import('/builds/gitlab/gitlab-ee/app/assets/javascripts/code_navigation/index.js?vue3').then((m) =>
      m.default({
        blobs: [{ path: blobPath, codeNavigationPath }],
        definitionPathPrefix,
      }),
    );
  }

  initTableOfContentsApp();

  return { router, apolloProvider };
}
